import { render, staticRenderFns } from "./ChatBoxModalAlert.vue?vue&type=template&id=07d4d432&scoped=true&"
import script from "./ChatBoxModalAlert.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalAlert.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalAlert.vue?vue&type=style&index=0&id=07d4d432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d4d432",
  null
  
)

export default component.exports